import { Injectable } from '@angular/core';
import { of } from 'rxjs';

/**
 * This class has to be extended and overriden
 * on the application using formrenderer library.
 */
@Injectable({
  providedIn: 'root',
})
export class BasePersonDetailsService {
  public getPersonDetails$() {
    return of({
      firstName: 'Mock',
      lastName: 'Mocksson',
      email: 'mocke90@mail.se',
    });
  }
}
